export const FINANCE_CATEGORY_NAMES = {
  DocumentsPayslips: 'Documents & Payslips',
  SalaryCalculations: 'Salary & Calculations',
  PaymentProcessing: 'Payment Processing',
} as const;

export const PAYSLIP_GUIDE_URLS = {
  redcore: 'https://wiki.time2go.tech/display/WORLD/How+to+check+your++payslip',
  twuAdmin: 'https://wiki.time2go.tech/pages/viewpage.action?pageId=362249329',
  twuMass: 'https://wiki.time2go.tech/pages/viewpage.action?pageId=362249370',
} as const;

export const III_WALLET_URLS = {
  faq: 'https://team.redcore.group/faq/iiiwallet',
  telegram: 'https://t.me/IIIWallet_support',
} as const;
